import type { RefOrGetter } from "ls/common/types";
import type { ShortcutJs } from "@/generated/models";
import { useQuery } from "@tanstack/vue-query";
import { getNavigateLink } from "ls/api/cloud/bookmark";
import { computed, toValue } from "vue";
import { queries } from "./queries";

export function useBookmarkUrl(shortcut: RefOrGetter<ShortcutJs | string>) {
  const { data: bookmark } = useQuery(computed(() => queries.bookmark(toValue(shortcut))));

  return {
    bookmark,
  };
}

export function useBookmarkMetadata(shortcut: RefOrGetter<ShortcutJs | string>) {
  const { bookmark } = useBookmarkUrl(shortcut);
  const { data: metadata, isError: isMetadataError } = useQuery(computed(() => queries.urlMetadata(bookmark.value?.Url)));

  return {
    bookmark,
    metadata,
    isMetadataError,
  };
}

export function useBookmarkNavigateUrl(shortcut: RefOrGetter<string>) {
  const navigateUrl = computed(() => getNavigateLink(toValue(shortcut)));
  return navigateUrl;
}
